import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Trade } from "@models";
import { FiatTransaction, TradableTransaction, Transaction } from "@models/transaction";
import { ActivitiesFacade, AssetGroupTransactions } from "@modules/home/components/activity-widget/activities.facade";
import { Observable } from "rxjs";

@Component({
	selector: "activity-widget",
	templateUrl: "./activity-widget.component.html",
	styleUrls: ["./activity-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ActivityWidgetComponent {
	private readonly activitiesFacade = inject(ActivitiesFacade);
	public assetGroupTransactions$: Observable<AssetGroupTransactions[]> =
		this.activitiesFacade.assetGroupTransactions$;

	public constructor() {
		this.activitiesFacade.loadActivities();
	}

	public isTradableTx(transaction: Transaction | Trade): boolean {
		return transaction instanceof TradableTransaction;
	}

	public isFiatTx(transaction: Transaction | Trade): boolean {
		return transaction instanceof FiatTransaction;
	}
}
